import styled, { css } from 'styled-components'
import { SvgScaniaWordmark } from '../../components/SvgImports'
import { TextId, useTextsV2 } from '../../utils/useTexts'
import { SuperCampaignData } from './SuperCampaignData'
import { SuperCampaignFooter } from './SuperCampaignFooter'
import { BreakpointWidthPx } from '../../css/BreakpointWidthPx'
import { BreakpointHeightPx } from '../../css/BreakpointHeightPx'

const paddingLeftRightPx = 40
const footerHeightPx = 96

interface DesktopBlueFooterAreaRootProps {
  $superCampaignEnabled: boolean
}

const DesktopFooterRoot = styled.div<DesktopBlueFooterAreaRootProps>`
  height: ${footerHeightPx}px;
  min-height: ${footerHeightPx}px;
  width: 100%;
  display: grid;

  ${(props) =>
    props.$superCampaignEnabled
      ? css`
          grid-template-columns: 1fr auto 1fr;
        `
      : css`
          grid-template-columns: 1fr 1fr;
        `}

  grid-column-gap: 8px;
  align-items: center;
  padding-left: ${paddingLeftRightPx}px;
  padding-right: ${paddingLeftRightPx}px;
  background-color: var(--tds-blue-800);

  @media screen and (max-width: ${BreakpointWidthPx.Large}px),
    screen and (max-height: ${BreakpointHeightPx.Large}px) {
    display: none;
  }
`

const LogotypeWrapper = styled.div`
  display: flex;
  justify-self: end;

  svg {
    height: 22px;
    width: auto;
    path {
      fill: var(--tds-white);
    }
  }
`

const CopyTextline = styled.p`
  margin: 0;
  white-space: nowrap;
`

interface DesktopFooterProps {
  superCampaignData?: SuperCampaignData
}

export function DesktopFooter({
  superCampaignData,
}: DesktopFooterProps): JSX.Element {
  const t2 = useTextsV2()
  const copyTextLines = t2(TextId.SCANIA_COPYRIGHT).trim().split('\n')

  return (
    <DesktopFooterRoot
      data-name="FooterDesktop"
      $superCampaignEnabled={!!superCampaignData}
    >
      <span style={{ color: 'var(--tds-grey-600)' }} className="tds-detail-05">
        {copyTextLines.map((line, i) => (
          <CopyTextline key={'copy-text-line-' + i + line}>{line}</CopyTextline>
        ))}
      </span>
      {superCampaignData && <SuperCampaignFooter {...superCampaignData} />}
      <LogotypeWrapper>
        <SvgScaniaWordmark />
      </LogotypeWrapper>
    </DesktopFooterRoot>
  )
}
